import {SafeUrl} from '@angular/platform-browser';
import { Image} from '@ks89/angular-modal-gallery';

export class PageItem {
  constructor(
    public id : string,
    public title : string,
    public excerpt : string,
    public content : string,
    public slug : string,
    public parent? : string,
    public background_image? : string,
    public link?: string,
    public publitas_link?: SafeUrl,
    public featuredmedia ? : any[],
    public gallery? : Array<Image>,
    public hasChild? : boolean,
    public childs?: PageItem[],
    public parent_title? : string,
    public language? : {
      current:string,
      es:{ slug:string},
      eu:{ slug:string},
    },
    public pdf?:any,
  ) {}

  // public set (key,attr) {
  //   this['key'] = attr;
  // }
}
